module.exports = __webpack_public_path__ + "static/media/A1_GLOSS.fc839144.png";